import React, { useEffect, useState } from 'react';
import { getFetch } from '../../../../../fetch/fetch';
import { Option, Select } from '@mui/joy';
import { buildMonthlyBreakdown } from '../functions/calcregisterrefund';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import totalLocationData from '../../../../../data/locationdata';
import { koreanLocationToEnglish } from '../../../../../data/locationFuntion';

const TotalSaleList: React.FC<any> = (props) => {

    const [selectedMonth, setSelectedMonth] = useState<string>(() => {
        const now = new Date();
        const date = new Date(now.getFullYear(), now.getMonth() + 1, 1);
        return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2);
    });
    const [update, setUpdate] = useState<number>(0);

    const [orderItemsData, setOrderItemsData] = useState<any[]>([]);

    const [alignment, setAlignment] = useState<string>('total');

    const [totalPaidAmount, setTotalPaidAmount] = useState<number>(0);


    useEffect(() => {

        getTotalPaymentList();

    }, [selectedMonth, update]);

    const getTotalPaymentList = async () => {

        try {

            const result: any = await getFetch("/dashboard/payments/totalpaymentlist?selectedMonth=" + selectedMonth);

            console.log("result");
            console.log(result);

            const orderItemsData = result.orderItemsData;

            if (orderItemsData && orderItemsData.length > 0) {

                orderItemsData.forEach((item: any) => {

                    console.log("item");

                    const result = buildMonthlyBreakdown(!item.isForced ? +item.paid_total : item.price, new Date(item.startDate), new Date(item.endDate), 10, true);

                    item.breakdown = result;

                });

            }

            console.log("orderItemsData");
            console.log(orderItemsData);

            const teacherData = result.teacherData;

            setOrderItemsData(orderItemsData);

        } catch (e) {
            console.log(e);
        }

    }

    useEffect(() => {

        console.log("orderItemsData changed");
        console.log(orderItemsData);

        calcData(orderItemsData, alignment);

    }, [orderItemsData, alignment]);

    const calcData = (data: any[], location: string) => {

        let totalPaid = 0;

        console.log(6);

        data.forEach((item) => {

            if(!item){
                return;
            }

            console.log(0)

            if (item.totalPaymentRecords.length === 0 && !item.isForced) {
                return;
            }

            console.log(1);

            const itemEnglishLocation = koreanLocationToEnglish(item.location);

            console.log(2)

            if(!itemEnglishLocation){
                return;
            }

            console.log(3);

            if(location !== "total" && itemEnglishLocation !== location){
                return;
            }

            console.log("item");
            console.log(item);

            

            if(item.breakdown && item.breakdown.length > 0){
                
                item.breakdown.forEach((each : any) => {

                    if(each.key !== selectedMonth){
                        return;
                    }

                    console.log("each.portion");
                    console.log(each.portion);

                    totalPaid += each.portion;

                });
            
            }

        });

        setTotalPaidAmount(totalPaid);


    }

    const handleChange = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {

        if(!newAlignment){
            return;
        }

        setAlignment(newAlignment);
    };

    return (
        <div>
            {/* 지금으로부터 12달 전까지 선택 가능 */}
            <Select
                value={selectedMonth}
                onChange={(e, newValue) => { setSelectedMonth(newValue as string) }}
                style={{
                    marginTop: "30px",
                    width: "250px",
                    marginBottom: "20px"
                }}
            >
                {
                    Array.from({ length: 12 }, (_, i) => {
                        const now = new Date();
                        const date = new Date(now.getFullYear(), now.getMonth() + 1 - i, 1);
                        const year = date.getFullYear();
                        const month = ("0" + (date.getMonth() + 1)).slice(-2);
                        const value = `${year}-${month}`;
                        return (
                            <Option key={value} value={value}>{value}</Option>
                        )
                    })
                }
            </Select>

            <div>
                <div style={{
                    marginBottom: "10px",
                    marginTop: "10px"
                }}>
                    <ToggleButtonGroup
                        color="primary"
                        value={alignment}
                        exclusive
                        onChange={handleChange}
                    >
                        {
                            props.user && totalLocationData.filter((each) => (each.academy.includes(props.user.academy)) || each.academy.includes("bundangsunbae")).map((each, index) => {
                                return (
                                    <ToggleButton value={each.english} key={index}>{each.korean}</ToggleButton>
                                )
                            })
                        }
                    </ToggleButtonGroup>
                </div>
            </div>

            <div>
                {
                    totalPaidAmount.toLocaleString() + "원"
                }
            </div>



        </div>
    )
}

export default TotalSaleList;